import { ChipStatus } from '@elementary/common-ui/components/Chip/StatusChip';
import { WarehouseType } from '@elementary/common-ui/types';
import { RuntimeConnectionHealth, RuntimeHealth } from './types';

export const RUNTIMES_DOCS_URL =
  'https://docs.elementary-data.com/cloud/features/elementary-runtime';

export const RUNTIME_CONFIGURATION_DOCS_URL = `${RUNTIMES_DOCS_URL}/configuration`;

export const RUNTIMES_BASE_PATH = '/settings/runtimes';

export const RUNTIME_HEALTH_CHIP_STATUS: Record<RuntimeHealth, ChipStatus> = {
  pending: 'pending',
  offline: 'error',
  issue: 'issue',
  healthy: 'success',
};

export const RUNTIME_CONNECTION_HEALTH_CHIP_STATUS: Record<
  RuntimeConnectionHealth,
  ChipStatus
> = {
  pending: 'pending',
  verified: 'success',
  failed: 'error',
};

export const CONNECTION_ERROR_MESSAGES: Record<string, string> = {
  authentication_failed: 'Credentials were rejected by the warehouse.',
  network_unreachable:
    "The runtime couldn't reach the warehouse over the network.",
  permission_denied:
    "The runtime's warehouse user is missing required permissions.",
  query_timeout: 'The verification query timed out.',
  query_failed: 'The verification query failed.',
};

export const RUNTIME_TOKEN_FILE_PATH = '/run/secrets/elementary_runtime_token';

export const WAREHOUSE_CREDENTIAL_PLACEHOLDERS: Partial<
  Record<WarehouseType, [string, string][]>
> = {
  snowflake: [
    ['account', '<your-account-identifier>'],
    ['user', '<runtime-user>'],
    ['password_file', '/run/secrets/snowflake_password'],
    ['role', '<runtime-role>'],
    ['warehouse', '<compute-warehouse>'],
    ['database', '<database>'],
  ],
  bigquery: [
    ['project', '<gcp-project-id>'],
    ['keyfile', '/run/secrets/bigquery_keyfile.json'],
  ],
  databricks: [
    ['host', '<workspace-host>'],
    ['http_path', '<sql-warehouse-http-path>'],
    ['token_file', '/run/secrets/databricks_token'],
  ],
  redshift: [
    ['host', '<cluster-host>'],
    ['user', '<runtime-user>'],
    ['password_file', '/run/secrets/redshift_password'],
    ['database', '<database>'],
  ],
  postgres: [
    ['host', '<database-host>'],
    ['user', '<runtime-user>'],
    ['password_file', '/run/secrets/postgres_password'],
    ['database', '<database>'],
  ],
};
